import React from 'react';
import styles from "./why-me.module.css";

const RULES = [
  'Книги выбирает ведущий клуба, никаких голосований и усреднений',
  'Не успели дочитать — все равно приходите. Мы учимся мыслить на контекстах, а не сдаем пересказ',
  'Регламент: встречи модерируются, у микрофона есть тайминг',
  'У нас нет «А тебе понравилась книга? А тебе?». Мы ведём раскопки, ставим невиданные науке вопросы и ломаем устои',
  'Мы реабилитируем вопрос «Что хотел сказать автор». Училка по литре не заслуживает таких почестей, как пожизненный бан столь прекрасного вопроса!',
];

const STATS = [
  {
    value: '3+ года',
    valueClass: styles.statValueGreen,
    tierClass: styles.statCardGreen,
    label: 'Ведение киноразборов и разборов книг',
    text: 'Онлайн, офлайн. Смешное, серьёзное. Сложное и простое.',
  },
  {
    value: '100%',
    valueClass: styles.statValueViolet,
    tierClass: styles.statCardViolet,
    label: 'Веселья',
    text: 'Мемы наши мемы. Достоевский писал, чтобы мы хохотали, это всем известно. ',
  },
];

const TRAITS = [
  {
    tierClass: styles.traitCyan,
    iconClass: styles.iconCyan,
    title: 'Все – норм',
    text: 'Все люди нормальные. Все мнения нормальные. Все углы для взглядов – тоже нормальные. Добро пожаловать в Нормгород!',
    icon: (<svg width="22" height="22" viewBox="64 64 896 896" fill="white" xmlns="http://www.w3.org/2000/svg">
  <path d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
</svg>)
  },
  {
    tierClass: styles.traitViolet,
    iconClass: styles.iconViolet,
    title: 'Глубина',
    text: <>Идём от простого к сложному. В конце <b>каждая</b> книга становится во много раз интереснее.</>,
    icon: (<svg width="22" height="22" viewBox="64 64 896 896" fill="white" xmlns="http://www.w3.org/2000/svg">
 <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
</svg>)
  },
  {
    tierClass: styles.traitPink,
    iconClass: styles.iconPink,
    title: 'Практическое применение',
    text: 'Весь мир станет интереснее, когда вы научитесь смотреть на него с интересом. Здесь мы тренируем интерес и убираем автоматическую реакцию бежать от Чужого.',
    icon: (<svg width="22" height="22" viewBox="64 64 896 896" fill="white" xmlns="http://www.w3.org/2000/svg">
<path d="M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"></path><path d="M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z"></path>
</svg>)
  },
  {
    tierClass: styles.traitPink,
    iconClass: styles.iconPink,
    title: 'Новое',
    text: 'Ставим новые вопросы и находим на них новые ответы. Всё в контексте группы, поэтому больше эти вопросы и ответы нигде не увидеть.',
    icon: (<svg width="22" height="22" viewBox="64 64 896 896" fill="white" xmlns="http://www.w3.org/2000/svg">
<path d="M512 472a40 40 0 1080 0 40 40 0 10-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z"></path>
</svg> )
  },
];
 

export const SectionWhyMe = () => {
  return (
    <section className={styles.sectionWhyMeContainer} id="whyme">
      <h2 className={styles.sectionWhyMeTitle}>Почему нормальный</h2>
      <div className={styles.sectionWhyMeWrap}>
        <div className={styles.sectionWhyMeInfoContainer}>
          <article className={styles.infoPanel}>
            <div className={styles.cardScanline} aria-hidden="true" />
            <div className={styles.cardCornerTL} aria-hidden="true" />
            <div className={styles.cardCornerBR} aria-hidden="true" />

            <ul className={styles.rulesList}>
              {RULES.map((rule) => (
                <li key={rule} className={styles.rulesItem}>{rule}</li>
              ))}
            </ul>

            <div className={styles.sectionWhyMeInfographicsContainer}>
              {STATS.map((stat) => (
                <div key={stat.label} className={`${styles.statCard} ${stat.tierClass}`}>
                  <p className={`${styles.statValue} ${stat.valueClass}`}>{stat.value}</p>
                  <p className={styles.statLabel}>{stat.label}</p>
                  <p className={styles.statText}>{stat.text}</p>
                </div>
              ))}
            </div>
          </article>
        </div>

        <div className={styles.sectionWhyMeCharacteristicsContainer}>
          {TRAITS.map((trait) => (
            <article
              key={trait.title}
              className={`${styles.sectionWhyMeCharacteristicsCard} ${trait.tierClass}`}
            >
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />

              <div className={`${styles.traitIcon} ${trait.iconClass}`}>
                {trait.icon}
              </div>
              <div className={styles.sectionWhyMecharacteristicsCardInfo}>
                <h4 className={styles.sectionWhyMecharacteristicsCardTitle}>{trait.title}</h4>
                <p className={styles.sectionWhyMecharacteristicsCardSubtitle}>{trait.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
